import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { CollapsibleWrapper, SeeMore } from "./Collapsible.styles";
export const Collapsible = (props) => {
    const ref = React.createRef();
    const [collapsed, setCollapsed] = React.useState(true);
    const [overflowing, setOverflowing] = React.useState(false);
    React.useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        if (collapsed) {
            const currentOverflowing = element.children[0].clientHeight < element.children[0].scrollHeight;
            setOverflowing(currentOverflowing);
        }
    });
    const { fontSize: memoFontSize, fontUnit: memoFontUnit } = React.useMemo(() => {
        const matches = props.fontSize.match(/^[0-9\\.]+/);
        if (!matches) {
            throw new Error(`Invalid fontSize: ${props.fontSize}`);
        }
        const fontSize = matches[0];
        const fontUnit = props.fontSize.substring(fontSize.length);
        return { fontSize, fontUnit };
    }, [props.fontSize]);
    return (_jsxs(CollapsibleWrapper, { maxLinesVisible: props.maxLinesVisible, fontSize: Number(memoFontSize), fontUnit: memoFontUnit, collapsed: collapsed, overflowing: overflowing, ref: ref, onClick: () => setCollapsed(!collapsed), children: [React.Children.only(props.children), _jsx(SeeMore, { children: collapsed ? "See more" : "See less" })] }));
};
